import { render, staticRenderFns } from "./baner-top-vertical.vue?vue&type=template&id=3578a5e8&"
import script from "./baner-top-vertical.vue?vue&type=script&lang=js&"
export * from "./baner-top-vertical.vue?vue&type=script&lang=js&"
import style0 from "./baner-top-vertical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports